import { render } from "./Index.vue?vue&type=template&id=e67651c4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=e67651c4&scoped=true&lang=css"

import exportComponent from "C:\\AgentPools\\FAOAgentPool\\_work\\20\\s\\PESVue\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e67651c4"]])

export default __exports__